/**
 * node_modules
 */
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

/**
 * styles
 */
import * as styles from "@features/Home/Outro/Outro.module.scss"

/**
 * components
 */
// import { Button } from "@components/Button"
import { ResponsiveImage } from "@components/ResponsiveImage"

/**
 * @function Outro
 * @description HOME/Outroセクション
 */
export const Outro = () => {
  /**
   * query
   */
  const data: Queries.HomeOutroDataQuery = useStaticQuery(graphql`
    query HomeOutroData {
      mobile: file(relativePath: { eq: "images/home/outro.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      desktop: file(relativePath: { eq: "images/home/outro-desktop.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allDataJson {
        nodes {
          home {
            outro {
              heading
              texts {
                id
                pcParagraph
                spParagraph
              }
              button {
                text
                url
              }
            }
          }
        }
      }
    }
  `)
  const jsonData = data.allDataJson.nodes
    .filter((item) => item.home !== null)
    .map((item) => item.home)
    .find((home) => home !== null)

  return (
    <section className={styles["outro"]}>
      <div className={styles["outro_bg"]}>
        <ResponsiveImage
          mobileImage={getImage(data.mobile!.childImageSharp!.gatsbyImageData)}
          desktopImage={getImage(data.desktop!.childImageSharp!.gatsbyImageData)}
          style={{ height: "100%" }}
          wrapperClassName={styles["outro_imageWrap"]}
        />
      </div>
      <div className={`${styles["outro_inner"]} ${styles["inner__sp"]}`}>
        <div className={styles["outro_text"]}>
          <h2>{jsonData!.outro!.heading!}</h2>
          <div className={`${styles["outro_story"]} ${styles["only__pc"]}`}>
            {jsonData!.outro!.texts!.map((text) => (
              <p key={text!.id}>
                <span>{text!.pcParagraph}</span>
              </p>
            ))}
          </div>
          <div className={`${styles["outro_story"]} ${styles["only__sp"]}`}>
            {jsonData!.outro!.texts!.map((text) => (
              <p key={text!.id}>
                <span>{text!.spParagraph}</span>
              </p>
            ))}
          </div>
          {/* Hidden in phase 1 */}
          {/* <div className={styles["outro_button"]}>
            <Button
              text={jsonData!.outro!.button!.text!}
              to={jsonData!.outro!.button!.url!}
              icon="external"
            />
          </div> */}
        </div>
      </div>
    </section>
  )
}
